import $ from "jquery";

import Field from "./../field";
import Dropdown from "./dropdown";

const Beds = (($) => {
  const OptionList = [
    { value: 1 },
    { value: 2 },
    { value: 3 },
    { value: 4 },
    { value: 5 },
    { value: 6 },
    { value: 7 },
    { value: 8 },
    { value: 9 },
    { value: 10 },
  ];

  return (field) => {
    return new Dropdown({ ...field, options: OptionList });
  };
})($);

export default Beds;
